module.exports = __webpack_public_path__ + "img/yjjxq.0556c26.png";